import { type createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { updatePersistor } from 'BreetHelpers';
import { type AppDispatch, logKybUserOut, type RootState, setKybCredentials } from 'BreetRedux';

export function kybListeners(mw: ReturnType<typeof createListenerMiddleware>) {
	const startAppListening = mw.startListening.withTypes<RootState, AppDispatch>();

	startAppListening({
		predicate: isPersistenceAction,
		effect: (_, api) => {
			const state = api.getState();
			updatePersistor({
				kybCredentials: state.kybAuth.kybCredentials,
			});
		},
	});
}

const isPersistenceAction = isAnyOf(setKybCredentials, logKybUserOut);
